import { assert_string_not_empty, assert_type_boolean, assert_type_enum, assert_type_string } from '@shared/asserts/utils_asserts';
import { ENUM__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__ui_theme } from '@shared/enums/ENUM__ui_theme';
import { FIELD_OF_TYPE } from '@shared/types/types';
import { ENUM__dto_class_name } from '../../../serialization/ENUM__dto_class_name';
import { DTO__database_entity } from '../../_database_entity/DTO__database_entity';

//id = user._id
export class DTO__user_settings extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.USER_SETTINGS;

  static readonly CLIENT_DEFAULT = new DTO__user_settings().clone({
    ui_grid2d_cell_size: ENUM__grid2d_cell_size.M,
    regional_use_english_tokens_in_prompt: false,
    _is_stub: true,
  });

  static KEYS_STRING: FIELD_OF_TYPE<DTO__user_settings>[] = ['default_workspace_id'];
  static KEYS_BOOLEAN: FIELD_OF_TYPE<DTO__user_settings>[] = [
    'confirm_action_delete_all_tokens',
    'confirm_action_image_to_text',
    'confirm_action_create_related_words',
    'generation_hide_unused_values',
    'generation_prompt_hide_unused_tokens',
    'generation_sampling_method_hide_unused_values',
    'generation_seed_hide_unused_values',
    'generation_seeds_hide_input',
    'regional_use_english_tokens_in_prompt',
    'search_prompt_hide_unused_tokens',
    'ui_grid2d_cells_sort_newest_first',
    'ui_hints_shortcuts_enabled',
  ];

  /*
   * DB FIELDS
   */

  /*
   * COLLECTIONS
   */

  /*
   * CONFIRMATION OF ACTIONS
   */

  confirm_action_delete_all_tokens!: boolean;
  confirm_action_image_to_text!: boolean;
  confirm_action_create_related_words!: boolean;

  /*
   * GENERATION
   */
  generation_autorun!: boolean;

  generation_hide_unused_values!: boolean;

  //prompt
  generation_prompt_hide_unused_tokens!: boolean;

  //sampling method
  generation_sampling_method_hide_unused_values!: boolean;

  //seed
  generation_seed_hide_unused_values!: boolean;
  //todo: implement
  generation_seeds_default!: number[];
  generation_seeds_hide_input!: boolean;

  generation_fields_show_read_only!: boolean;

  generation_show_hidden_generations!: boolean;

  /*
   * REGIONAL
   */
  regional_language!: string;
  regional_use_english_tokens_in_prompt!: boolean;

  /*
   * SEARCH
   */
  search_prompt_hide_unused_tokens!: boolean;

  /*
   * HINTS SHORTCUT
   */
  ui_hints_shortcuts_enabled!: boolean;

  /*
   * UI
   */
  ui_theme!: string;

  ui_grid2d_cell_size!: ENUM__grid2d_cell_size;
  ui_grid2d__show_image_info!: boolean;
  ui_grid2d_cells_sort_newest_first!: boolean;

  /*
   * WORKSPACE
   */
  default_workspace_id!: string;
  /*
   * METHODS
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_type_boolean(this.generation_autorun);

    assert_type_enum(this.regional_language, ENUM__language_type);
    assert_type_enum(this.ui_theme, ENUM__ui_theme);
    assert_type_enum(this.ui_grid2d_cell_size, ENUM__grid2d_cell_size);

    for (let key of DTO__user_settings.KEYS_STRING) {
      assert_type_string(this[key]);
      assert_string_not_empty(this[key]);
    }

    for (let key of DTO__user_settings.KEYS_BOOLEAN) {
      assert_type_boolean(this[key]);
    }
  }
}
